<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-circle-plus-outline"
          @click="add"
          >添加</el-button
        >
        <el-button size="mini" type="primary" plain @click="check">
          预设
        </el-button>
      </div>
      <div class="search_box">
        <el-select
          size="mini"
          v-model="requestData.templateType"
          clearable
          placeholder="请选择告知类型"
        >
          <el-option label="告知卡" :value="1"> </el-option>
          <el-option label="告知栏" :value="2"> </el-option>
          <el-option label="重大风险公告栏" :value="3"> </el-option>
        </el-select>
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-search"
          @click="searchData"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="responseData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column label="序号" width="70" align="center">
            <template v-slot="scope">
              {{
                requestData.pageSize * (requestData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>

          <el-table-column
            prop="templateType"
            label="告知类型"
            width="120"
            align="center"
          >
            <template v-slot="scope">
              <div v-if="scope.row.templateType == 1">告知卡</div>
              <div v-if="scope.row.templateType == 2">告知栏</div>
              <div v-if="scope.row.templateType == 3">重大风险公告栏</div>
            </template>
          </el-table-column>
          <el-table-column prop="headerName" label="标题" align="center">
          </el-table-column>
          <el-table-column prop="post" label="岗位/危险源名称" align="center">
          </el-table-column>
          <el-table-column
            prop="typesAccidents"
            label="易发事故类型/风险类型"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="mainRiskFactors"
            label="主要风险因素/风险因素"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="emergencyCall" label="应急电话" align="center">
          </el-table-column>
          <el-table-column
            prop="addTime"
            label="创建时间"
            width="152"
            align="center"
          >
            <template v-slot="scope">
              <div>{{ $Common.dateFormatDateTwo(scope.row.addTime) }}</div>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="180">
            <template v-slot="scope">
              <el-link
                type="primary"
                @click="edit(scope.row)"
                :underline="false"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-dropdown>
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      class="link_box"
                      type="primary"
                      @click="preview(scope.row)"
                      :underline="false"
                      >预览</el-link
                    ></el-dropdown-item
                  >
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      class="link_box"
                      type="primary"
                      @click="del(scope.row.id)"
                      :underline="false"
                      >删除</el-link
                    ></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div>
    </div>
    <risk-notice-template-add
      :addResize="addResize"
      @getList="getList"
    ></risk-notice-template-add>
    <operate-one
      :operateResize="operateResizeOne"
      :detail="detail"
      :operateType="operateType"
      @getList="getList"
    ></operate-one>
    <operate-two
      :operateResize="operateResizeTwo"
      :detail="detail"
      :operateType="operateType"
      @getList="getList"
    ></operate-two>
    <operate-three
      :operateResize="operateResizeThree"
      :detail="detail"
      :operateType="operateType"
      @getList="getList"
    ></operate-three>
    <preview-one
      :previewResize="previewResizeOne"
      :detail="detail"
    ></preview-one>
    <preview-Two
      :previewResize="previewResizeTwo"
      :detail="detail"
    ></preview-Two>
    <preview-Three
      :previewResize="previewResizeThree"
      :detail="detail"
    ></preview-Three>
    <select-default
      :resize="defaultResize"
      :templateType="templateType"
    ></select-default>
  </div>
</template>

<script>
import RiskNoticeTemplateAdd from "./components/RiskNoticeTemplateAdd";
import operateOne from "./components/RiskNoticeTemplateOperateOne";
import operateTwo from "./components/RiskNoticeTemplateOperateTwo";
import operateThree from "./components/RiskNoticeTemplateOperateThree";
import previewOne from "./components/RiskNoticeTemplatePreviewOne";
import previewTwo from "./components/RiskNoticeTemplatePreviewTwo";
import previewThree from "./components/RiskNoticeTemplatePreviewThree";
import selectDefault from "./components/RiskNoticeTemplateDefault";
export default {
  name: "",
  components: {
    RiskNoticeTemplateAdd,
    operateOne,
    operateTwo,
    operateThree,
    previewOne,
    previewTwo,
    previewThree,
    selectDefault
  },
  props: {},
  data() {
    return {
      dataList: [],

      requestData: {
        schoolId: this.$store.state.schoolId, // 学校id
        pageNum: 1,
        pageSize: 20,
        templateType: ""
      },
      responseData: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },
      addResize: 0,
      operateResizeOne: 0,
      operateResizeTwo: 0,
      operateResizeThree: 0,
      detail: {},
      operateType: 0, // 0 不使用预设数据 1 使用
      previewResizeOne: 0,
      previewResizeTwo: 0,
      previewResizeThree: 0,
      templateType: 0,
      defaultResize: 0
    };
  },
  created() {
    this.getList();
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    add() {
      this.addResize++;
    },
    check() {
      let templateType = this.requestData.templateType;
      if (templateType == "") {
        this.templateType = 1;
      } else {
        this.templateType = templateType;
      }
      this.defaultResize++;
    },
    edit(info) {
      this.detail = info;
      this.$confirm("是否使用预设数据?", "提示", {
        confirmButtonText: "使用",
        cancelButtonText: "不使用",
        closeOnClickModal: false
        // type: "warning"
      })
        .then(() => {
          this.operateType = 1;
          if (info.templateType == 1) {
            this.operateResizeOne++;
          } else if (info.templateType == 2) {
            this.operateResizeTwo++;
          } else {
            this.operateResizeThree++;
          }
        })
        .catch(() => {
          this.operateType = 0;
          if (info.templateType == 1) {
            this.operateResizeOne++;
          } else if (info.templateType == 2) {
            this.operateResizeTwo++;
          } else {
            this.operateResizeThree++;
          }
        });
    },
    preview(info) {
      this.detail = info;
      if (info.templateType == 1) {
        this.previewResizeOne++;
      } else if (info.templateType == 2) {
        this.previewResizeTwo++;
      } else {
        this.previewResizeThree++;
      }
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      console.log(`当前页: ${val}`);
      this.getList();
    },
    searchData() {
      this.requestData.pageNum = 1;
      this.getList();
    },
    // 获取告知模板列表
    async getList() {
      let req = this.requestData;
      let res = await this.$Http.getNoticeTemplateList(req, true);
      if (res.code == 200) {
        this.responseData = res.data;
      } else if (res.code == 101) {
        this.responseData.total = 0;
        this.responseData.list = [];
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    del(id) {
      this.$confirm("此操作将永久删除该模板, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.delNotice(id);
        })
        .catch(() => {});
    },
    // 删除告知模板
    async delNotice(id) {
      let req = {
        id: id
      };
      let res = await this.$Http.delNoticeTemplate(req, true);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功!"
        });
        this.getList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 图片上传
    async imgUpload(event) {
      let uploadInfo = await this.$Common.fileUpload(event);
      if (uploadInfo) {
        this.insertData.url = uploadInfo.fileUrl;
        this.editData.url = uploadInfo.fileUrl;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.el-table {
  &:before {
    display: none;
  }
}
.el-select {
  margin-left: 10px;
}
.button-box {
  padding: 5px;
}
</style>
